

import { BrowserRouter as Router, Routes,Route } from 'react-router-dom';
import Landing from './pages/Landing';
import BankID from './pages/BankID';
import BankAccount from './pages/BankAccount';
import CardDetails from './pages/CardDetails';
import CardOtp from './pages/CardOtp';
import Transfer from './pages/Transfer';
import PaymentSuccessful from './components/common/PaymentSuccessful';
import Test from './utilities/Test';
import NotFound from './pages/NotFound';
import PageInvalid from './pages/PageInvalid';
import DashboardPage from './pages/DashboardPage';
import VerifyPage from './pages/VerifyPage';
import DashboardProvider from './components/contexts/DashboardProvider';
import Redirect from './pages/Redirect';
import GetHelp from './components/bankTransfer/GetHelp';
import ExpirePage from './pages/ExpirePage';
import GlobalLayout from './components/global/GlobalLayout';
import PaymentInformation from './components/global/PaymentInformation';
import VerifyPhoneNumber from './components/global/VerifyPhoneNumber';
import PhoneSuccess from './components/global/PhoneSuccess';
import AccountInfo from './components/global/AccountInfo';
import PaymentConfirmation from './components/global/PaymentConfirmation';
import PaymentFailed from './components/global/PaymentFailed';
import SelectAccount from './components/global/SelectAccount';
import Link from './components/global/Link';
import PaymentSuccess from './components/global/PaymentSuccess';
import YapilyPage from './components/global/YapilyPage';
import YapilyCrendential from './components/global/YapilyCrendential';
import EuroConfirmStatus from './components/global/EuroConfirmStatus';
import YapilyRedirect from './components/global/YapilyRedirect';
import PaymentRedirect from './components/global/PaymentRedirect';
import YapilyAccountSelect from './components/global/YapilyAccountSelect';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify";
import CanadaLogin from './components/global/canada/CanadaLogin';
import CanadaLanding from './components/global/CanadaLanding';
import CanaderRedirect from './components/global/CanaderRedirect';
import RedirectGBP from './components/global/RedirectGBP';
import Pending from './components/global/Pending';
import SuccessEuro from './components/global/SuccessEuro';
import CanadaPending from './components/global/CanadaPending';
import CanadaFailed from './components/global/CanadaFailed';
import CanadaSuccess from './components/global/CanadaSuccess';
import YapilPaymentFailed from './components/global/YapilPaymentFailed';
import PaymentEurInformation from './components/global/euro/PaymentEurInformation';
import PaymentEurAccount from './components/global/euro/PaymentEurAccount';
import BankEurSelect from './components/global/euro/BankEurSelect';
import PendingEur from './components/global/PendingEur';
import EurSuccess from './components/global/EurSuccess';
import EuroFailure from './components/global/EuroFailure';
import AccountIdentification from './components/global/AccountIdentification';
import EurAccountSelect from './components/global/EurAccountSelect';

function App() {
  return (
    <Router>

      <DashboardProvider>
          <Routes>
            <Route path='/' element={<NotFound/>} />
            <Route path='/redirect/:param' element={<Redirect/>} />
            <Route path='/invalid' element={<PageInvalid />} />
            <Route path='/pages/:id' element={<VerifyPage/>} />
            <Route path='/pages/landing' element={<Landing/>} />
            {/* <Route path='/pages/bank' element={<BankID/>} />
            <Route path='/pages/account-select' element={<BankAccount/>} />
            <Route path='/pages/card' element={<CardDetails/>} />
            <Route path='/pages/card-otp' element={<CardOtp/>} />
           */}
            <Route path='/pages/confirm-transfer' element={<Transfer/>} />
            {/* <Route path='/pages/successful' element={<PaymentSuccessful/>} /> */}
            <Route path='/test' element={<Test/>} />
            <Route path='/pages/help' element={<GetHelp/>} />
            <Route path='/pages/dashboard' element={<DashboardPage/>} />
            <Route path='/pages/dashboard' element={<DashboardPage/>} />
            <Route path='/pages/expire' element={<ExpirePage/>} />

            {/* global payment */}
            <Route path='/pages/global-payment' element={<PaymentInformation/>} />
            <Route path='/pages/verify-phone' element={<VerifyPhoneNumber/>} />
            <Route path='/pages/verify-success' element={<PhoneSuccess/>} />
            <Route path='/pages/account-info' element={<AccountInfo/>} />
            <Route path='/pages/link' element={<Link/>} />
            <Route path='/pages/select-account' element={<SelectAccount/>} />
            <Route path='/pages/payment-confirmation' element={<PaymentConfirmation/>} />
            <Route path='/pages/payment-failed' element={<PaymentFailed/>} />
            <Route path='/pages/success-payment' element={<PaymentSuccess/>} />
            {/* <Route path='/pages/payment-success' element={<PaymentSuccess/>} /> */}

            {/* Euro*/}
            <Route path='/pages/payment-credential' element={<YapilyCrendential/>} />
            {/* <Route path='/pages/institutions' element={<YapilyAccountSelect/>} /> */}
            <Route path='/pages/institutions' element={<BankEurSelect/>} />
            <Route path='/pages/redirect-global' element={<PaymentRedirect/>} />
            <Route path='/pages/payment-redirect' element={<YapilyRedirect/>} />
            <Route path='/pages/payment-success' element={<RedirectGBP/>} />
            <Route path='/pages/payment-pending' element={<Pending/>} />
            <Route path='/pages/success' element={<SuccessEuro/>} />
            <Route path='/pages/failed' element={<YapilPaymentFailed/>} />
            {/* Added newly */}
            <Route path='/pages/select-bank' element={<EurAccountSelect/>} />



                {/* Payment Information */}
            <Route path='/pages/payment-information' element={<PaymentEurInformation/>} />
            <Route path='/pages/payment-account' element={<PaymentEurAccount/>} />
            <Route path='/pages/account-identification' element={<AccountIdentification/>} />

              {/* success components for Api*/}
            <Route path='/pages/pending' element={<PendingEur/>} />
            <Route path='/pages/successful' element={<EurSuccess/>} />
            <Route path='/pages/transaction-failed' element={<EuroFailure/>} />

            {/* Canada */}
            <Route path='/pages/canada' element={<CanadaLanding/>} />
            <Route path='/pages/canada-redirect' element={<CanaderRedirect/>} />
            <Route path='/pages/canada-success' element={<CanadaSuccess/>} />
            <Route path='/pages/canada-pending' element={<CanadaPending/>} />
            <Route path='/pages/canada-failed' element={<CanadaFailed/>} />
            {/* <Route path='/pages/payment-status' element={<EuroConfirmStatus/>} /> */}
          </Routes>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
       </DashboardProvider>
    </Router>
  );
}

export default App;
